import { Meter } from 'portal/components/Utilities/Meters/Interface'

export const METERS_LOAD = 'METERS_LOAD'
export const metersLoad = (
  accountId: string,
  projectId: string
): MetersLoadAction => ({
  type: METERS_LOAD,
  accountId,
  projectId
})

export const METERS_LOAD_SUCCESS = 'METERS_LOAD_SUCCESS'
export const metersLoadSuccess = (
  accountId: string,
  projectId: string,
  meters: Meter[]
): MetersLoadSuccessAction => ({
  type: METERS_LOAD_SUCCESS,
  accountId,
  projectId,
  meters
})

export const METERS_LOAD_FAIL = 'METERS_LOAD_FAIL'
export const metersLoadFailure = (
  accountId: string,
  projectId: string,
  error
): MetersLoadFailAction => ({
  type: METERS_LOAD_FAIL,
  accountId,
  projectId,
  error
})

export const ADD_METER = 'ADD_METER'
export const addMeter = (
  accountId: string,
  projectId: string,
  meterName: string,
  meterReference: string,
  utilityType: string,
  reload: () => void,
  showSuccessNotification: () => void,
  showFailureNotification: () => void
): AddMeterAction => ({
  type: ADD_METER,
  accountId,
  projectId,
  meterName,
  meterReference,
  utilityType,
  reload,
  showSuccessNotification,
  showFailureNotification
})

export const ADD_METER_SUCCESS = 'ADD_METER_SUCCESS'
export const addMeterSuccess = (
  accountId: string,
  projectId: string,
  meter: Meter
): AddMeterSuccessAction => ({
  type: ADD_METER_SUCCESS,
  accountId,
  projectId,
  meter
})

export const ADD_METER_FAIL = 'ADD_METER_FAIL'
export const addMeterFailure = (
  accountId: string,
  projectId: string,
  error: any
): AddMeterFailAction => ({
  type: ADD_METER_FAIL,
  accountId,
  projectId,
  error
})

export const EDIT_METER = 'EDIT_METER'
export const editMeter = (
  accountId: string,
  projectId: string,
  meterId: string,
  meterName: string,
  meterReference: string,
  utilityType: string,
  reload: () => void,
  showSuccessNotification: () => void,
  showFailureNotification: () => void
): EditMeterAction => ({
  type: EDIT_METER,
  accountId,
  projectId,
  meterId,
  meterName,
  meterReference,
  utilityType,
  reload,
  showSuccessNotification,
  showFailureNotification
})

export const EDIT_METER_SUCCESS = 'EDIT_METER_SUCCESS'
export const editMeterSuccess = (
  accountId: string,
  projectId: string,
  meter: Meter
): EditMeterSuccessAction => ({
  type: EDIT_METER_SUCCESS,
  accountId,
  projectId,
  meter
})

export const EDIT_METER_FAIL = 'EDIT_METER_FAIL'
export const editMeterFailure = (
  accountId: string,
  projectId: string,
  error: any
): EditMeterFailAction => ({
  type: EDIT_METER_FAIL,
  accountId,
  projectId,
  error
})

export const DELETE_METER = 'DELETE_METER'
export const deleteMeter = (
  accountId: string,
  projectId: string,
  meterId: string,
  reload: () => void,
  showSuccessNotification: () => void,
  showFailureNotification: () => void
): DeleteMeterAction => ({
  type: DELETE_METER,
  accountId,
  projectId,
  meterId,
  reload,
  showSuccessNotification,
  showFailureNotification
})

export const DELETE_METER_SUCCESS = 'DELETE_METER_SUCCESS'
export const deleteMeterSuccess = (
  accountId: string,
  projectId: string,
  meter: Meter
): DeleteMeterSuccessAction => ({
  type: DELETE_METER_SUCCESS,
  accountId,
  projectId,
  meter
})

export const DELETE_METER_FAIL = 'DELETE_METER_FAIL'
export const deleteMeterFailure = (
  accountId: string,
  projectId: string,
  meterId: string,
  error: any
): DeleteMeterFailAction => ({
  type: DELETE_METER_FAIL,
  accountId,
  projectId,
  meterId,
  error
})

// INTERFACEs
export interface MetersLoadAction {
  type: typeof METERS_LOAD
  accountId: string
  projectId: string
}

interface MetersLoadSuccessAction {
  type: typeof METERS_LOAD_SUCCESS
  accountId: string
  projectId: string
  meters: Meter[]
}

interface MetersLoadFailAction {
  type: typeof METERS_LOAD_FAIL
  accountId: string
  projectId: string
  error: any
}

export interface AddMeterAction {
  type: typeof ADD_METER
  accountId: string
  projectId: string
  meterName: string
  meterReference: string
  utilityType: string
  reload: () => void
  showSuccessNotification: () => void
  showFailureNotification: () => void
}

interface AddMeterSuccessAction {
  type: typeof ADD_METER_SUCCESS
  accountId: string
  projectId: string
  meter: Meter
}

interface AddMeterFailAction {
  type: typeof ADD_METER_FAIL
  accountId: string
  projectId: string
  error: any
}

export interface EditMeterAction {
  type: typeof EDIT_METER
  accountId: string
  projectId: string
  meterId: string
  meterName: string
  meterReference: string
  utilityType: string
  reload: () => void
  showSuccessNotification: () => void
  showFailureNotification: () => void
}
interface EditMeterSuccessAction {
  type: typeof EDIT_METER_SUCCESS
  accountId: string
  projectId: string
  meter: Meter
}
interface EditMeterFailAction {
  type: typeof EDIT_METER_FAIL
  accountId: string
  projectId: string
  error: any
}

export interface DeleteMeterAction {
  type: typeof DELETE_METER
  accountId: string
  projectId: string
  meterId: string
  reload: () => void
  showSuccessNotification: () => void
  showFailureNotification: () => void
}
interface DeleteMeterSuccessAction {
  type: typeof DELETE_METER_SUCCESS
  accountId: string
  projectId: string
  meter: Meter
}
interface DeleteMeterFailAction {
  type: typeof DELETE_METER_FAIL
  accountId: string
  projectId: string
  meterId: string
  error: any
}
